import * as React from 'react';
const SvgDropDownIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={8} fill="none" {...props}>
    <path
      fill="#7B867C"
      d="M11 1.17a1 1 0 0 0-1.41 0L6 4.71 2.46 1.17a1 1 0 1 0-1.41 1.42l4.24 4.24a1 1 0 0 0 1.42 0L11 2.59a.998.998 0 0 0 0-1.42Z"
    />
  </svg>
);
export default SvgDropDownIcon;
